import { render, staticRenderFns } from "./DraftSales.vue?vue&type=template&id=467b30f8&scoped=true&"
import script from "./DraftSales.vue?vue&type=script&lang=js&"
export * from "./DraftSales.vue?vue&type=script&lang=js&"
import style0 from "./DraftSales.vue?vue&type=style&index=0&id=467b30f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b30f8",
  null
  
)

export default component.exports